var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.423,
    height: 16.265,
    viewBox: "0 0 17.423 16.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M8.761.53l-2,3.943-4.478.634a.946.946,0,0,0-.543,1.626L4.978,9.8l-.766,4.333a.975.975,0,0,0,1.422,1L9.64,13.09l4.006,2.046a.975.975,0,0,0,1.422-1L14.3,9.8l3.24-3.067A.946.946,0,0,0,17,5.106l-4.478-.634L10.52.53a1,1,0,0,0-1.759,0Z",
    transform: "translate(-0.929 0.501)",
    fill: "#eaf7ea",
    stroke: "#0c7b0f",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStarEmpty);
export default __webpack_public_path__ + "static/media/green-star-empty.8a9f23b2d472aaead09c3b254ae292a0.svg";
export { ForwardRef as ReactComponent };